import * as React from "react";
import { Select } from "antd";
const Option = Select.Option;
import { connect } from "react-redux";

interface ICountryProps {
  width?: number;
  getCountry?: any;
  getCity?: any;
  resetCity?: any;
  setValue?: any;
  share?: any;
  // 默认值
  defaultValue?: any;
  value?: any;
  style?: React.CSSProperties;
  // 自定义字段，映射viewModel的字段
  "data-field"?: any;
  "city-field"?: any;
  "area-field"?: any;
  isLoadCity?: any;
  modelName?: any;
  onChange?: any;
}

class Country extends React.Component<ICountryProps, any> {
  constructor(props: ICountryProps) {
    super(props);
    if (this.props.value && this.props.isLoadCity) {
      this.props.getCity(this.props.value);
    }
  }

  componentDidMount() {
    this.props.getCountry && this.props.getCountry();
  }

  // 更改国家数据项时触发
  onChangeCountry = e => {
    // 重置城市数据集
    this.props.resetCity();

    // 重置城市，区域选择项
    let data = { model: this.props.modelName, formInfo: {} };
    data.formInfo[this.props["city-field"]] = "";
    data.formInfo[this.props["area-field"]] = "";
    this.props.setValue(data);

    // 初始化城市数据
    console.log("this.props.isLoadCity", this.props.isLoadCity);
    if (this.props.isLoadCity) {
      this.props.getCity(e);
    }
    this.props.onChange && this.props.onChange(e, this.props["data-field"]);
  };

  render() {
    const list = this.props.share.country;
    const mapList = () => {
      let options: any = [];
      for (const item of list) {
        options.push(
          <Option key={item.id} value={item.id}>
            {item.name}
          </Option>
        );
      }
      return options;
    };
    // 当数据已加载完成时才设置选中的值,这样处理可以避免由于数据集为加载而造成的闪烁
    const value = this.props.share.country.length
      ? this.props.value || undefined
      : undefined;

    // 根据关键字检索option
    const filter = (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return (
      <Select
        style={{ width: this.props.width || 200 }}
        // this.props.value 不能为空
        value={value}
        // 显示一个x，可以清除当前选择的数据
        allowClear={true}
        placeholder="选择国家"
        onChange={this.onChangeCountry}
        // 检索相关
        showSearch
        optionFilterProp="children"
        filterOption={filter}
        // 检索相关
      >
        {mapList()}
      </Select>
    );
  }
}

const mapState = state => ({
  share: state.share
});

const mapDispatch = dispatch => {
  return {
    getCountry: dispatch.region.getCountry,
    getCity: dispatch.region.getCity,
    // 重置城市数据
    resetCity: dispatch.share.resetCity,
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  mapState,
  mapDispatch
)(Country);
